class FlipCards extends HTMLElement {
    constructor() {
        super();
        
        this.showSlide = this.showSlide.bind(this);
        this.updateCardWidth = this.updateCardWidth.bind(this);
    }

    connectedCallback() {
        this.setupElements();
        this.addEventListeners();
    }

    setupElements() {
        this.flipCards = this.querySelectorAll(".flip-card__content-wrapper");
        this.prevSlide = this.querySelector(".slider-buttons svg.prev");
        this.nextSlide = this.querySelector(".slider-buttons svg.next");
        this.scrollable = this.querySelector(".flip-card__container");
        this.cardWidth = this.flipCards[0].offsetWidth;

    }

    addEventListeners() {
        this.flipCards.forEach((card) => {
            card.addEventListener('click', () => {
                card.classList.toggle("active");
            });
        });
        this.prevSlide.addEventListener('click', () => { this.showSlide("prev") });
        this.nextSlide.addEventListener('click', () => { this.showSlide("next") });
        window.addEventListener('resize', this.updateCardWidth);

        let startX, startY;

        this.scrollable.addEventListener('touchstart', (event) => {
            startX = event.touches[0].clientX;
            startY = event.touches[0].clientY;
        });

        this.scrollable.addEventListener('touchend', (event) => {
            const endX = event.changedTouches[0].clientX;

            const swipeBuffer = 50; // Adjust this value as needed

            // Calculate how much the user swiped
            const deltaX = Math.abs(endX - startX);

            // Check if scrolled to the right edge and user swiped enough
            const maxScrollLeft = this.scrollable.scrollWidth - this.scrollable.clientWidth;
            if (this.scrollable.scrollLeft === maxScrollLeft && deltaX > swipeBuffer) {
                // Scroll back to the front
                this.scrollable.scrollTo({ left: 0, behavior: 'smooth' });
            }
        });
    }

    updateCardWidth() {
        this.cardWidth = this.flipCards[0].offsetWidth;
    }

    showSlide(type) {
        const cardIndex = Math.floor(this.scrollable.scrollLeft / this.cardWidth);
        const scrollableWidth = this.scrollable.clientWidth;
        const cardsInView = Math.floor(scrollableWidth / this.cardWidth);

        let targetIndex;
        let newScrollLeft;

        if (type === "next") {
            targetIndex = cardIndex + cardsInView;
            newScrollLeft = this.cardWidth * targetIndex + (this.cardWidth - scrollableWidth) / 2;
        } else {
            targetIndex = cardIndex - cardsInView;
            newScrollLeft = this.cardWidth * targetIndex - (this.cardWidth - scrollableWidth) / 2;
        }

        const maxScrollLeft = this.scrollable.scrollWidth - scrollableWidth;

        // Reset back to first card when pressing next at the end
        if (type === "next" && newScrollLeft >= maxScrollLeft) {
            newScrollLeft = Math.min(newScrollLeft, 0);
        }

        this.scrollable.scroll({
            left: newScrollLeft,
            behavior: "smooth"
        })
    }

    cloneCards() {
        const firstCard = this.flipCards[0];
        const lastCard = this.flipCards[this.flipCards.length - 1];

        const clonedFirstCard = firstCard.cloneNode(true);
        const clonedLastCard = lastCard.cloneNode(true);

        this.scrollable.appendChild(clonedFirstCard);
        this.scrollable.insertBefore(clonedLastCard, firstCard);
    }
}

if(!customElements.get("flip-card-item")){
    customElements.define("flip-cards", FlipCards)
}